export default __webpack_public_path__ + "static/web/media/values.cdafc5bc.jpg";